import React, { Component } from 'react'
import SplashScreen from './SplashScreen';
import ErrorPage from '../ErrorPage'
import Results from '../Results'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import '../../assets/css/mobile.css'

export class AppMobile extends Component {



  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={SplashScreen} />
          <Route path="/results/:resultId" component={Results} />
          <Route component={ErrorPage} />
        </Switch>
      </BrowserRouter>
    )
  }
}

export default AppMobile
